<template>
    <div>
        <div id="bai-du-map"></div>
        <div class="top-btn-box">
            <van-button class="submit" @click="submit" type="primary">确定</van-button>
        </div>
        <div class="input-special-style">
            <div class="contener">
                <div class="left">当前位置：</div>
                <van-field v-model="keyword" placeholder="请输入搜索关键词" />
                <van-button class="submit" @click="search" type="primary">搜索</van-button>
            </div>
            <div id="panel"></div>
        </div>
    </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';

window._AMapSecurityConfig = {
    // 设置安全密钥
    securityJsCode: '5ac9b921bf06bcaf20ef264c3270a77c'
};
export default {
    props: ['iptId'],
    data() {
        return {
            centerMarker: {
                lng: 0,
                lat: 0
            },
            map: null,
            isAdd: false,
            keyword: '',
            placeSearch: null
        };
    },
    methods: {
        search() {
            this.placeSearch.search(this.keyword, function(status, result) {
                // console.log(status, result);
                // 查询成功时，result即对应匹配的POI信息
            });
        },
        submit() {
            this.$router.push({
                path: '/add-or-edit-md',
                query: { isAdd: this.isAdd, fullAddress: this.keyword, latitude: this.centerMarker.lat, longitude: this.centerMarker.lng }
            });
        },
        updateCenterMarker() {
            // 更新中心标记点的经纬度
            const center = this.map.getCenter();
            this.centerMarker.lng = center.getLng();
            this.centerMarker.lat = center.getLat();
        },
        initMap() {
            const that = this;
            AMapLoader.load({
                key: 'd8a05279e7291c0866b66fff3b803b40', // 申请好的Web端开发者Key，首次调用 load 时必填
                version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                plugins: [
                    'AMap.ElasticMarker',
                    'AMap.Geocoder',
                    'AMap.Geolocation',
                    'AMap.CitySearch',
                    'AMap.AutoComplete',
                    'AMap.PlaceSearch'
                ]
            })
                .then(AMap => {
                    // this.AMap = AMap;
                    this.map = new AMap.Map('bai-du-map', {
                        // 设置地图容器id
                        viewMode: '2D', // 是否为3D地图模式
                        zoom: 15, // 初始化地图级别
                        resizeEnable: true
                    });

                    // 获取地图中心点的经纬度
                    const center = this.map.getCenter();
                    this.centerMarker.lng = center.getLng();
                    this.centerMarker.lat = center.getLat();
                    // 在地图中添加中心标记点
                    // 监听地图拖动事件，更新中心标记点的位置
                    let marker;
                    this.map.on('dragend', () => {
                        const center = this.map.getCenter();
                        this.centerMarker.lng = center.getLng();
                        this.centerMarker.lat = center.getLat();
                        marker && marker.remove();
                        marker = new AMap.Marker({
                            position: center,
                            map: this.map
                        });

                        // 逆编码查询
                        var geocoder = new AMap.Geocoder({
                            city: '攀枝花' // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                        });
                        var lnglat = [center.lng, center.lat];
                        geocoder.getAddress(lnglat, function(status, result) {
                            if (status === 'complete' && result.info === 'OK') {
                                // result为对应的地理位置详细信息
                                that.keyword = result.regeocode.formattedAddress;
                            }
                        });
                    });
                    // 逆编码查询
                    var geocoder = new AMap.Geocoder({
                        city: '攀枝花' // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                    });
                    var lnglat = [center.lng, center.lat];
                    geocoder.getAddress(lnglat, function(status, result) {
                        if (status === 'complete' && result.info === 'OK') {
                            // result为对应的地理位置详细信息
                            that.keyword = result.regeocode.formattedAddress;
                        }
                    });

                    // 搜索相关
                    this.placeSearch = new AMap.PlaceSearch({
                        pageSize: 2, // 单页显示结果条数
                        pageIndex: 1, // 页码
                        citylimit: true, // 是否强制限制在设置的城市内搜索
                        map: this.map, // 展现结果的地图实例
                        panel: 'panel', // 结果列表将在此容器中进行展示。
                        autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
                    });
                    this.placeSearch.on('listElementClick', ({ event, data }) => {
                        // console.log(event, data);
                        this.keyword = data.pname + data.cityname + data.adname + data.address;
                        this.centerMarker.lat = data.location.lat;
                        this.centerMarker.lng = data.location.lng;
                    });
                })
                .catch(e => {
                    console.log(e);
                });
        }
    },
    created() {},
    mounted() {
        this.isAdd = this.$route.query.isAdd;
        console.log(this.isAdd);
        this.initMap();
    }
};
</script>

<style scoped lang="scss">
#bai-du-map {
    padding: 0px;
    margin: 0px;
    width: 100%;
    height: 800px;
}

/* 隐藏高德logo  */
.amap-logo {
    display: none !important;
}
/* 隐藏高德版权  */
.amap-copyright {
    display: none !important;
}
.top-btn-box {
    position: fixed;
    top: 2%;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 0 20px;
}
.input-special-style {
    height: auto;
    position: fixed;
    bottom: 5%;
    left: 0;
    right: 0;
    margin: 0 10px;
    padding: 10px;
    background-color: #fff;

    .contener {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 15px;

        .left {
            white-space: nowrap;
        }
        .submit {
            white-space: nowrap;
        }
    }
}
</style>
